import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";
import { PointPricePositionEnum, GenderEnum } from "@altertec_gparn/lib";

export class UpdateUserDto {
  @Expose()
  id?: string;

  @Expose()
  companyId?: string;

  @Expose()
  collectiveAgreementId?: string;

  @Expose()
  collectiveAgreementCategoryId?: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  hiredDate?: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  lastEmploymentDate?: Date;

  @Expose()
  operativeUnitId?: string;

  @Expose()
  pointPricePosition?: PointPricePositionEnum | null;

  @Expose()
  firstName?: string;

  @Expose()
  lastName?: string;

  @Expose()
  creditCardHolderName?: string;

  @Transform(({ value }) => {
    const normalizedValue = typeof value === "string" ? value.trim() : value;
    return normalizedValue ? normalizedValue : undefined;
  })
  @Expose()
  internalCode?: string;

  @Expose()
  personalEmail?: string;

  @Expose()
  dni?: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  dniExpirationDate?: Date;

  @Expose()
  passport?: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  passportExpirationDate?: Date;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  dateOfBirth?: Date;

  @Expose()
  gender?: GenderEnum | null;

  @Expose()
  personalPhone1?: string;

  @Expose()
  personalPhone2?: string;

  @Expose()
  companyPhone1?: string;

  @Expose()
  companyPhone2?: string;

  @Expose()
  extension?: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  hourlyRate?: number;

  @Expose()
  isPlannable?: boolean;

  @Expose()
  idWinda?: string;
}
